import { render } from "./ListTasks.vue?vue&type=template&id=1f843d26&scoped=true"
import script from "./ListTasks.vue?vue&type=script&lang=js"
export * from "./ListTasks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp8\\htdocs\\AI4IRGClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f843d26"]])

export default __exports__